import { TreeItem } from '@/interfaces/treeItem';

/**
 * Buduje drzewo
 *
 * @export
 * @param {TreeItem[]} treeItems
 * @returns
 */
export function buildTree(treeItems: TreeItem[]) {
  return treeItems.reduce((roots: TreeItem[], treeItem) => {
    if (!!treeItem.parent) {
      const parent = treeItems.find(r => {
        if (treeItem.parent !== undefined) {
          return r.id === treeItem.parent.id;
        }
      });
      parent ? addToParent(parent, treeItem) : roots.push(treeItem);
    } else {
      roots.push(treeItem);
    }
    return roots;
  }, []);
}

/**
 * Ustawia węzeł jako dziecko
 *
 * @param {TreeItem} parent
 * @param {TreeItem} treeItem
 */
function addToParent(parent: TreeItem, treeItem: TreeItem) {
  if (parent.children) {
    parent.children.push(treeItem);
  } else {
    parent.children = [treeItem];
  }
}
